import Vue from "vue";
import VueRouter from "vue-router";
import "@mdi/font/css/materialdesignicons.css";
import Buefy from "buefy";
import VueMeta from "vue-meta";
import VueMatomo from "vue-matomo";
import Home from "../views/Home.vue";

Vue.use(VueRouter);
Vue.use(Buefy);
Vue.use(VueMeta);
Vue.use(VueMatomo, {
  host: "https://metrics.vvandel.io",
  siteId: 6,
  trackerFileName: "matomo",
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  rackInitialView: true,
  disableCookies: true,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: [],
});

const routes = [
  // Main Pages
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/honig",
    name: "Honig",
    component: () => import("../views/Honig.vue"),
  },
  {
    path: "/ueber-uns",
    name: "Über uns",
    component: () => import("../views/Ueberuns.vue"),
  },
  /*{
    path: "/wildblumen",
    name: "Wildblumen",
    component: () => import("../views/Wildblumen.vue"),
  },*/
  {
    path: "/bluehbuffet",
    name: "Blühbuffet",
    component: () => import("../views/Bluehbuffet.vue"),
  },
  {
    path: "/bienenoasen",
    name: "Bienenoasen",
    component: () => import("../views/Bienenoasen.vue"),
  },
  {
    path: "/kontakt",
    name: "kontakt",
    component: () => import("../views/Kontakt.vue"),
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import("../views/FAQ.vue"),
  },
  {
    path: "/landwirte",
    name: "Für Landwirte",
    component: () => import("../views/Landwirte.vue"),
  },
  // legal pages
  {
    path: "/datenschutz",
    name: "Datenschutz",
    component: () => import("../views/legal/Datenschutz.vue"),
  },
  {
    path: "/impressum",
    name: "Impressum",
    component: () => import("../views/legal/Impressum.vue"),
  },
  {
    path: "/agb",
    name: "AGB",
    component: () => import("../views/legal/Agb.vue"),
  },
  // response pages
  {
    path: "/bienenpost",
    name: "Bienenpost",
    component: () => import("../views/response/Bienenpost.vue"),
  },
  {
    path: "/bienenpost-step-2",
    name: "Bienenpost Schritt 2",
    component: () => import("../views/response/Bienenpostoptin.vue"),
  },
  {
    path: "/bluehkarte",
    name: "Blühkarte",
    component: () => import("../views/response/Bluehkarte.vue"),
  },
  //occasions
  {
    path: "/freude-schenken",
    name: "Corona",
    component: () => import("../views/occasions/Corona.vue"),
  },
  {
    path: "/bienenweide-patenschaft",
    name: "Einfach so",
    component: () => import("../views/occasions/Einfachso.vue"),
  },
  {
    path: "/originelles-mitbringsel",
    name: "Feier",
    component: () => import("../views/occasions/Feier.vue"),
  },
  {
    path: "/blumen-verschenken-zur-geburt",
    name: "Geburt",
    component: () => import("../views/occasions/Geburt.vue"),
  },
  {
    path: "/nachhaltiges-geburtstagsgeschenk",
    name: "Geburtstag",
    component: () => import("../views/occasions/Geburtstag.vue"),
  },
  {
    path: "/gastgeschenk-hochzeit",
    name: "Hochzeit",
    component: () => import("../views/occasions/Hochzeit.vue"),
  },
  {
    path: "/originelles-geschenk-hochzeitstag",
    name: "Hochzeitstag",
    component: () => import("../views/occasions/Hochzeitstag.vue"),
  },
  {
    path: "/nachhaltiges-geschenk-jubilaeum",
    name: "Jubiläum",
    component: () => import("../views/occasions/Jubilaeum.vue"),
  },
  {
    path: "/blumen-zur-konfirmation",
    name: "Konfirmation",
    component: () => import("../views/occasions/Konfirmation.vue"),
  },
  {
    path: "/mittsommer",
    name: "Mittsommer",
    component: () => import("../views/occasions/Mittsommer.vue"),
  },
  {
    path: "/blumen-verschenken-trotz-lockdown",
    name: "Lockdown",
    component: () => import("../views/occasions/Lockdown.vue"),
  },
  {
    path: "/originelle-idee-zum-muttertag",
    name: "Muttertag",
    component: () => import("../views/occasions/Muttertag.vue"),
  },
  {
    path: "/bluehpatenschaft-zu-ostern",
    name: "Ostern",
    component: () => import("../views/occasions/Ostern.vue"),
  },
  {
    path: "/nachhaltiges-weihnachtsgeschenk",
    name: "Weihnachten",
    component: () => import("../views/occasions/Weihnachten.vue"),
  },
  {
    path: "/blumen-zum-valentinstag",
    name: "Valentinstag",
    component: () => import("../views/occasions/Valentinstag.vue"),
  },
  {
    path: "/verlaengern",
    name: "Verlaengern",
    component: () => import("../views/occasions/Verlaengern.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkActiveClass: "is-active",
});

export default router;
